/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Outcomeformsummaryother3Inputs */

const en_outcomeformsummaryother3 = /** @type {(inputs: Outcomeformsummaryother3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logged on ${i?.when}`)
};

const pt_outcomeformsummaryother3 = /** @type {(inputs: Outcomeformsummaryother3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registo de ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Logged on {when}" |
*
* @param {Outcomeformsummaryother3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeformsummaryother3 = /** @type {((inputs: Outcomeformsummaryother3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeformsummaryother3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeformsummaryother3(inputs)
	return pt_outcomeformsummaryother3(inputs)
});
export { outcomeformsummaryother3 as "outcomeFormSummaryOther" }